import styled, { css } from 'styled-components';
import { mediaMap } from '@belong/themes';
import { MediaMapResult, ResponsiveProp } from '@belong/types';
import { UnstyledList } from '../../styles/List';

export type ColumnOptions = number | 'auto';
export interface IColumnLayout {
  hasColumns?: ResponsiveProp<ColumnOptions>;
}

export const ColumnLayout = styled(UnstyledList)<IColumnLayout>`
  ${({ hasColumns }): MediaMapResult =>
    mediaMap(
      hasColumns,
      columnCount => css`
        column-count: ${columnCount};
      `
    )}
`;
